import axios from 'axios';
import _ from 'lodash';
import store from 'app/store';
import { getDeferralsQuery, getUsersQuery } from './queries';
import { getBulkQueryData } from './utils';
import { arrayToMap } from '../../utils';
import { requiresProducerBusinessData } from './utils/regionUtils';

const getDeferralListDetails = async (startDate, endDate) => {
    try {
        const { region } = store.getState().persisted.auth.user.data;
        const deferralResponse = await axios.get(getDeferralsQuery(startDate, endDate));
        let deferrals = deferralResponse.data;

        // Only get producer business data if required for this region
        const needsProducerBusinessData = requiresProducerBusinessData(region);

        if (needsProducerBusinessData) {
            // Extract producer business IDs from the deferrals data
            const producerBusinessIds = _.filter(_.uniq(_.map(deferrals, (deferral) => deferral.producer?.producer_business)), (id) => id != null);

            if (producerBusinessIds.length > 0) {
                // Fetch producer business details
                const producerBusinesses = await getBulkQueryData(getUsersQuery, {
                    fields: ['id', 'license_number', 'name'],
                    ids: producerBusinessIds,
                });

                // Create a map of producer businesses by ID
                const producerBusinessMap = arrayToMap(producerBusinesses, 'id');

                // Add producer business details to each deferral
                deferrals = deferrals.map((deferral) => {
                    const producerBusinessId = deferral.producer?.producer_business;
                    if (producerBusinessId) {
                        const producerBusiness = producerBusinessMap[producerBusinessId];
                        if (producerBusiness) {
                            return {
                                ...deferral,
                                producer_business_name: producerBusiness.name || '',
                                producer_business_number: producerBusiness.license_number || '',
                            };
                        }
                    }
                    return deferral;
                });
            }
        }

        return { deferrals };
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        throw new Error('Unable to process request.');
    }
};

export default getDeferralListDetails;
